import React from 'react';
import { Box, Typography } from '@mui/material';

export default function RentalTerms({ terms }) {
  if (!terms?.paragraphs) return null;
  return <Box component="details" sx={{ my: 2 }}>
    <summary>{terms.title} · редакция {terms.version}</summary>
    {terms.paragraphs.map((text, index) => <Typography key={index} variant="body2" sx={{ mt: 1 }}>{text}</Typography>)}
  </Box>;
}
